import { Card, Modal } from 'ant-design-vue';
import { h } from 'vue';

export default (title: string, card_title: string, field_list: Array<any>, res: any) => {
  const p = { style: { width: '25%', 'text-align': 'center', padding: '10px' } };
  const children: any = [];
  for (const k of field_list) {
    children.push(h(Card.Grid, { ...p }, k.name + ':'));
    children.push(h(Card.Grid, { ...p }, res[k.value]));
  }
  Modal.info({
    title: title,
    width: 800,
    content: h(Card, { title: card_title }, children),
    onOk() {
      console.log('ok');
    },
  });
};
